import AchHelp from "../ach-help";
import classes from "../../classes";
import expandable from "../higher-order/expandable";
import FormError from "../../components/form-error";
import { Map } from "immutable";
import React from "react";

export default expandable(class AchDepositForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.toggleHelp = this.toggleHelp.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();
    var { deposit, history, onSubmit, session } = this.props;
    onSubmit(
      session.get("user_id"),
      deposit.get("amount"),
      this.refs.routingNumber.value,
      this.refs.accountNumber.value,
      history
    );
  }

  toggleHelp(e) {
    e.preventDefault();
    var { toggle } = this.props;
    toggle();
  }

  render() {
    var { communications, expanded, session, toggle } = this.props;

    var routingNumber;
    var accountNumber;
    var account = session.getIn(["checking_accounts", 0]);
    if (account) {
      routingNumber = account.get("routing_number");
      accountNumber = account.get("account_number");
    }

    var help;
    if (expanded) {
      help = <AchHelp onClose={toggle} />;
    }

    var loading = communications.getIn(["ach_deposit", "state"]) === "in progress";
    var errors = communications.getIn(["ach_deposit", "error"]) || Map();

    return (
      <form className="form--is-horizontal" onSubmit={this.onSubmit}>
        <div className="batch-g batch-g--padding batch-g--valign-center">
          <div className="batch-c-1-1 batch-c-md-1-4 text-right" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <h3>
              Automated Clearing House (ACH)
            </h3>
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="routing-number">
              Routing Number
              {" "}

              <button className="dw-help_outline dw--1-25x" onClick={this.toggleHelp} type="button" />
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" defaultValue={routingNumber} id="routing-number" maxLength="9" name="routing-number" placeholder="Routing Number (Must be 9 digits.)" ref="routingNumber" type="number" />

            <FormError error={errors.get("routing_number")} name="Routing Number" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="account-number">
              Account Number
              {" "}

              <button className="dw-help_outline dw--1-25x" onClick={this.toggleHelp} type="button" />
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" defaultValue={accountNumber} id="account-number" name="account-number" placeholder="Account Number" ref="accountNumber" type="number" />

            <FormError error={errors.get("account_number")} name="Account Number" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <div className="form_action">
              <input
                className={classes({
                  "btn": true,
                  "btn--primary": true,
                  "btn--is-loading": loading,
                })}
                disabled={loading}
                type="submit"
                value={loading ? "Processing" : "Deposit From ACH"} />
            </div>
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <p className="note-text">
              I agree to pay merchant a returned item fee of $25.00, which may be intitiated to my account for the items returned unpaid. I further acknowledge that I have completely read, understand and received a copy of this agreement. Any returned items not resolved within 10 business days will be deducted from the customer account or turned over to a collection agency.
            </p>

            <p className="note-text">
              By clicking &quot;Deposit From ACH&quot; above, I hereby authorize Horse Racing Labs LLC to initiate a debit, in the amount indicated, to my checking/savings account in the depository financial institution (Bank) identified by the routing number indicated, and a bank to debit same to such account. I acknowledge that I have received services/goods in consideration hereof and I further agree that this authorization shall be non-recoverable.
            </p>
          </div>
        </div>

        {help}
      </form>
    );
  }
});
